import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';
import { osirisTokens } from '@/theme/tokens';

interface SectionHeaderProps {
  title: ReactNode;
  right?: ReactNode;
  className?: string;
  sx?: SxProps<Theme>;
}

export function SectionHeader({ title, right, className, sx }: SectionHeaderProps) {
  return (
    <Box
      className={`section-header${className ? ' ' + className : ''}`}
      sx={[
        {
          height: osirisTokens.layout.sectionHeaderHeight,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          pl: 2,
          pr: 0.5,
          bgcolor: osirisTokens.bg.header,
          // borderTop: `1px solid ${osirisTokens.border.primary}`,
          flexShrink: 0,
          minWidth: 0,
          overflow: 'hidden',
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      <Typography
        // div, not p: titles may be composite nodes (e.g. SessionLogsPanel
        // passes a Box), and a div inside a p is invalid HTML
        component="div"
        sx={{
          fontFamily: osirisTokens.fonts.display,
          fontSize: 13,
          fontWeight: 400,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: osirisTokens.text.primary,
          flexShrink: 0,
        }}
      >
        {title}
      </Typography>
      {right && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            height: '100%',
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          {right}
        </Box>
      )}
    </Box>
  );
}
